import type { PolicySource, RegionPolicy } from "../types";

export const policyVersion = "2026-06-17.production.2";

export const policySources = [
  {
    id: "gov-2024-delayed-retirement",
    title: "全国人民代表大会常务委员会关于实施渐进式延迟法定退休年龄的决定",
    publisher: "全国人民代表大会常务委员会",
    url: "https://www.gov.cn/yaowen/liebiao/202409/content_6974294.htm",
    publishedDate: "2024-09-13",
    accessedDate: "2026-06-17"
  },
  {
    id: "gov-2005-pension-system",
    title: "国务院关于完善企业职工基本养老保险制度的决定",
    publisher: "国务院",
    url: "https://www.gov.cn/zwgk/2005-12/14/content_127311.htm",
    publishedDate: "2005-12-14",
    accessedDate: "2026-06-17"
  },
  {
    id: "gov-2009-transfer",
    title: "城镇企业职工基本养老保险关系转移接续暂行办法",
    publisher: "国务院办公厅",
    url: "https://www.gov.cn/zwgk/2009-12/29/content_1499072.htm",
    publishedDate: "2009-12-29",
    accessedDate: "2026-06-17"
  },
  {
    id: "gov-2019-rate-base",
    title: "国务院办公厅关于印发降低社会保险费率综合方案的通知",
    publisher: "国务院办公厅",
    url: "https://www.gov.cn/zhengce/content/2019-04/04/content_5379629.htm",
    publishedDate: "2019-04-04",
    accessedDate: "2026-06-17"
  },
  {
    id: "bj-2025-contribution-base",
    title: "北京市2025年度各项社会保险缴费工资基数上下限通告",
    publisher: "北京市人力资源和社会保障局;北京市医疗保障局;国家税务总局北京市税务局",
    url: "https://www.beijing.gov.cn/zhengce/zhengcefagui/202509/t20250918_4205116.html",
    publishedDate: "2025-09-18",
    accessedDate: "2026-06-17"
  },
  {
    id: "bj-2025-benefit-base",
    title: "北京市2025年参保人员社会保险待遇有关问题通告",
    publisher: "北京市人力资源和社会保障局;北京市财政局;国家税务总局北京市税务局",
    url: "https://rsj.beijing.gov.cn/xxgk/2024zcwj/202511/t20251107_4265291.html",
    publishedDate: "2025-11-07",
    accessedDate: "2026-06-17"
  },
  {
    id: "sh-2025-contribution-base",
    title: "上海市调整2025年度社保缴费基数上下限公告",
    publisher: "上海市人力资源和社会保障局",
    url: "https://rsj.sh.gov.cn/tgsgg_17341/20250918/t0035_1435637.html",
    publishedDate: "2025-09-18",
    accessedDate: "2026-06-17"
  },
  {
    id: "gd-2025-pension-base",
    title: "广东省2025年职工基本养老保险缴费基数上下限和基本养老金计发基数通知",
    publisher: "广东省人力资源和社会保障厅;广东省财政厅;国家税务总局广东省税务局",
    url: "https://hrss.gd.gov.cn/zwgk/xxgkml/bmwj/qtwj/shbz/content/post_4789618.html",
    publishedDate: "2025-10-27",
    accessedDate: "2026-06-17",
    note: "深圳市基本养老金计发基数另行公布，本快照使用 sz-2025-benefit-base 补充。"
  },
  {
    id: "sz-2025-benefit-base",
    title: "深圳市2025年职工基本养老金计发基数问答",
    publisher: "深圳市人力资源和社会保障局",
    url: "https://hrss.sz.gov.cn/zmhd/cjwt/cjwt/shbz/content/post_12493488.html",
    publishedDate: "2025-11-17",
    accessedDate: "2026-06-17"
  },
  {
    id: "zh-2025-social-disclosure",
    title: "2025年度珠海市社会保险信息披露",
    publisher: "珠海市人力资源和社会保障局;珠海市医疗保障局",
    url: "https://zhsi.zhuhai.gov.cn/sbsj/content/post_3898523.html",
    publishedDate: "2026-04-21",
    accessedDate: "2026-06-17"
  },
  {
    id: "zj-2025-social-base",
    title: "浙江省关于公布2025年社会保险有关基数的通知政策解读",
    publisher: "浙江省人力资源和社会保障厅",
    url: "https://zhejiang.chinatax.gov.cn/art/2025/9/18/art_7575_642624.html",
    publishedDate: "2025-09-18",
    accessedDate: "2026-06-17"
  },
  {
    id: "sc-2025-social-base",
    title: "四川省2025年度社保缴费基数公告",
    publisher: "四川省人力资源和社会保障厅",
    url: "https://www.sc.gov.cn/10462/10464/10797/2025/9/22/078c785f2dcd407ba50e9a37121535fe.shtml",
    publishedDate: "2025-09-22",
    accessedDate: "2026-06-17"
  },
  {
    id: "tj-2025-wage-base",
    title: "天津市2024年度全市职工平均工资及2025年度工资福利待遇标准通知",
    publisher: "天津市人力资源和社会保障局;天津市医疗保障局;国家税务总局天津市税务局",
    url: "https://tianjin.chinatax.gov.cn/11200000000/0300/030004/03000419/20250929153537383.shtml",
    publishedDate: "2025-09-29",
    accessedDate: "2026-06-17"
  },
  {
    id: "tj-2025-benefit-base",
    title: "天津市2025年度基本养老金计发基数政策问答",
    publisher: "天津市人力资源和社会保障局",
    url: "https://hrss.tj.gov.cn/zhengwugongkai////zhengcezhinan/zcjdnew/202511/t20251117_7179567.html",
    publishedDate: "2025-11-17",
    accessedDate: "2026-06-17"
  },
  {
    id: "hb-2025-social-base",
    title: "湖北省2025年度社会保险缴费基数标准通知",
    publisher: "湖北省人力资源和社会保障厅;湖北省医疗保障局;国家税务总局湖北省税务局",
    url: "https://rst.hubei.gov.cn/zfxxgk/zc/qtzdgkwj/202509/t20250919_5775307.shtml",
    publishedDate: "2025-09-19",
    accessedDate: "2026-06-17"
  }
] as const satisfies readonly PolicySource[];

export const regions: RegionPolicy[] = [
  {
    code: "CN-11",
    name: "北京",
    year: 2025,
    averageWage: 11937,
    pensionBase: 12049,
    baseMin: 7162,
    baseMax: 35811,
    employeePersonalRate: 0.08,
    accountCreditRate: 0.08,
    source: "bj-2025-contribution-base",
    sourceRefs: ["bj-2025-contribution-base", "bj-2025-benefit-base"]
  },
  {
    code: "CN-31",
    name: "上海",
    year: 2025,
    averageWage: 12434,
    pensionBase: 12434,
    baseMin: 7460,
    baseMax: 37302,
    employeePersonalRate: 0.08,
    accountCreditRate: 0.08,
    source: "sh-2025-contribution-base",
    sourceRefs: ["sh-2025-contribution-base"]
  },
  {
    code: "CN-44",
    name: "广东（广州/省直）",
    year: 2025,
    averageWage: 9183,
    pensionBase: 9493,
    baseMin: 5510,
    baseMax: 27549,
    employeePersonalRate: 0.08,
    accountCreditRate: 0.08,
    source: "gd-2025-pension-base",
    sourceRefs: ["gd-2025-pension-base"]
  },
  {
    code: "CN-44-OTHER",
    name: "广东（其他地市，不含深圳）",
    year: 2025,
    averageWage: 9183,
    pensionBase: 9493,
    baseMin: 4775,
    baseMax: 27549,
    employeePersonalRate: 0.08,
    accountCreditRate: 0.08,
    source: "gd-2025-pension-base",
    sourceRefs: ["gd-2025-pension-base"]
  },
  {
    code: "CN-44-SZ",
    name: "深圳",
    year: 2025,
    averageWage: 9183,
    pensionBase: 11293,
    baseMin: 4775,
    baseMax: 27549,
    employeePersonalRate: 0.08,
    accountCreditRate: 0.08,
    source: "sz-2025-benefit-base",
    sourceRefs: ["gd-2025-pension-base", "sz-2025-benefit-base"]
  },
  {
    code: "CN-44-ZH",
    name: "珠海",
    year: 2025,
    averageWage: 9183,
    pensionBase: 9493,
    baseMin: 4775,
    baseMax: 27549,
    employeePersonalRate: 0.08,
    accountCreditRate: 0.08,
    source: "zh-2025-social-disclosure",
    sourceRefs: ["gd-2025-pension-base", "zh-2025-social-disclosure"]
  },
  {
    code: "CN-33",
    name: "浙江",
    year: 2025,
    averageWage: 8433,
    pensionBase: 8433,
    baseMin: 4986,
    baseMax: 25299,
    employeePersonalRate: 0.08,
    accountCreditRate: 0.08,
    source: "zj-2025-social-base",
    sourceRefs: ["zj-2025-social-base"]
  },
  {
    code: "CN-33-HZ",
    name: "杭州",
    year: 2025,
    averageWage: 8433,
    pensionBase: 8433,
    baseMin: 4986,
    baseMax: 25299,
    employeePersonalRate: 0.08,
    accountCreditRate: 0.08,
    source: "zj-2025-social-base",
    sourceRefs: ["zj-2025-social-base"]
  },
  {
    code: "CN-51",
    name: "四川",
    year: 2025,
    averageWage: 7646,
    pensionBase: 7646,
    baseMin: 4588,
    baseMax: 22938,
    employeePersonalRate: 0.08,
    accountCreditRate: 0.08,
    source: "sc-2025-social-base",
    sourceRefs: ["sc-2025-social-base"]
  },
  {
    code: "CN-51-CD",
    name: "成都",
    year: 2025,
    averageWage: 7646,
    pensionBase: 7646,
    baseMin: 4588,
    baseMax: 22938,
    employeePersonalRate: 0.08,
    accountCreditRate: 0.08,
    source: "sc-2025-social-base",
    sourceRefs: ["sc-2025-social-base"]
  },
  {
    code: "CN-12",
    name: "天津",
    year: 2025,
    averageWage: 8540,
    pensionBase: 9417,
    baseMin: 5124,
    baseMax: 25620,
    employeePersonalRate: 0.08,
    accountCreditRate: 0.08,
    source: "tj-2025-wage-base",
    sourceRefs: ["tj-2025-wage-base", "tj-2025-benefit-base"]
  },
  {
    code: "CN-42",
    name: "湖北（武汉/省直）",
    year: 2025,
    averageWage: 7496,
    pensionBase: 7496,
    baseMin: 4498,
    baseMax: 22488,
    employeePersonalRate: 0.08,
    accountCreditRate: 0.08,
    source: "hb-2025-social-base",
    sourceRefs: ["hb-2025-social-base"]
  },
  {
    code: "CN-42-T2",
    name: "湖北（二档地市）",
    year: 2025,
    averageWage: 7226,
    pensionBase: 7226,
    baseMin: 4299,
    baseMax: 21678,
    employeePersonalRate: 0.08,
    accountCreditRate: 0.08,
    source: "hb-2025-social-base",
    sourceRefs: ["hb-2025-social-base"]
  },
  {
    code: "CN-42-T3",
    name: "湖北（三档地市）",
    year: 2025,
    averageWage: 7154,
    pensionBase: 7154,
    baseMin: 4254,
    baseMax: 21462,
    employeePersonalRate: 0.08,
    accountCreditRate: 0.08,
    source: "hb-2025-social-base",
    sourceRefs: ["hb-2025-social-base"]
  }
];

export const regionMap = new Map(regions.map((region) => [region.code, region]));

export const payoutMonthFactors: Record<number, number> = {
  50: 195,
  51: 190,
  52: 185,
  53: 180,
  54: 175,
  55: 170,
  56: 164,
  57: 158,
  58: 152,
  59: 145,
  60: 139,
  61: 132,
  62: 125,
  63: 117,
  64: 109,
  65: 101
};

export function getRegion(code: string): RegionPolicy {
  return regionMap.get(code) ?? regions[0];
}
